import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { LanguageToggle } from '../components/ui/LanguageToggle';
export function Terms() {
  const {
    lang
  } = useLanguage();
  const content = lang === 'es' ? <>
        <h1 data-id="element-640" data-mp="79fxs13qlh39">Términos de Servicio</h1>
        <p className="muted" data-id="element-641" data-mp="7ahjr0majnzr">Última actualización: 11 de julio de 2026</p>

        <h2 data-id="element-642" data-mp="c8sr94p45met">1. Aceptación de los términos</h2>
        <p data-id="element-643" data-mp="c7zijy6lgmu1">
          Al acceder y utilizar este Sitio, usted acepta estos Términos de
          Servicio. Si no está de acuerdo con ellos, no utilice el Sitio.
        </p>

        <h2 data-id="element-644" data-mp="la8tgp5ryi7y">2. Naturaleza del sitio</h2>
        <p data-id="element-645" data-mp="l74hv6pzck79">
          Este Sitio es informativo y está diseñado para facilitar solicitudes
          de consulta. La información presentada no constituye asesoramiento
          médico, diagnóstico ni tratamiento, y no establece una relación
          médico-paciente.
        </p>

        <h2 data-id="element-646" data-mp="2s06wn83fozpt">3. Solicitud de consulta</h2>
        <p data-id="element-647" data-mp="239cttxr4wbsf">
          Completar una solicitud de consulta no garantiza un procedimiento,
          resultado, cita ni candidatura. Cada caso se evalúa individualmente
          por el equipo médico para determinar su idoneidad y un plan
          personalizado.
        </p>

        <h2 data-id="element-648" data-mp="1thguykh84hn5">4. Programa de mensajes SMS</h2>
        <p data-id="element-649" data-mp="1pihqt23bgowr">
          Al proporcionar su consentimiento para mensajes de texto, acepta
          recibir mensajes de Dermaclinic LA LLC relacionados con recordatorios
          de citas, actualizaciones de cuenta y ofertas promocionales. La
          frecuencia de los mensajes puede variar según su interacción con
          nosotros.
        </p>
        <p data-id="element-650" data-mp="2d5pnivmoipn6">
          Pueden aplicarse tarifas de mensajes y datos. El consentimiento para
          recibir mensajes SMS no es una condición para comprar servicios.
        </p>

        <h2 data-id="element-651" data-mp="11t591dtxb8iu">5. Instrucciones para cancelar mensajes</h2>
        <p data-id="element-652" data-mp="wtkav5mkv476">
          Puede cancelar los mensajes SMS en cualquier momento enviando
          <strong data-id="element-653" data-mp="wvn747ebptkc"> STOP</strong>. Recibirá un mensaje de confirmación y no se
          enviarán más mensajes, salvo que vuelva a otorgar su consentimiento.
        </p>

        <h2 data-id="element-654" data-mp="13910wyod5h9n">6. Soporte de mensajes</h2>
        <p data-id="element-655" data-mp="p9rqygqr3je4">
          Para obtener ayuda, envíe <strong data-id="element-656" data-mp="p8q8vsbbhwmw">HELP</strong> por mensaje de texto o
          escríbanos a{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-657" data-mp="talidk3ejgbr">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>

        <h2 data-id="element-658" data-mp="finh1vfxmoq5">7. Disponibilidad y responsabilidad de carriers</h2>
        <p data-id="element-659" data-mp="kayij2qbmikt">
          Los carriers no son responsables por mensajes retrasados o no
          entregados. La entrega de mensajes depende de la disponibilidad de la
          red inalámbrica, el proveedor de servicios y otros factores fuera de
          nuestro control.
        </p>

        <h2 data-id="element-660" data-mp="3spymfzz0iabt">8. Restricción de edad</h2>
        <p data-id="element-661" data-mp="3sr0ar651gtbh">
          Debe tener al menos 18 años de edad para otorgar consentimiento y
          recibir mensajes SMS de Dermaclinic LA LLC.
        </p>

        <h2 data-id="element-662" data-mp="3e3jis2chkyj1">9. Política de Privacidad</h2>
        <p data-id="element-663" data-mp="3e4bb94aseg53">
          Para conocer cómo recopilamos, utilizamos y protegemos su información,
          revise nuestra <Link to="/privacy" data-id="element-664" data-mp="396j9likcbfnp">Política de Privacidad</Link>.
        </p>

        <h2 data-id="element-665" data-mp="3n5iviiggxgg6">10. Resultados individuales</h2>
        <p data-id="element-666" data-mp="3n24txcfmpb9s">
          Los resultados estéticos varían entre pacientes según factores como
          anatomía individual, estilo de vida, edad, salud general y
          cumplimiento del plan de recuperación. No garantizamos resultados
          específicos.
        </p>

        <h2 data-id="element-667" data-mp="3s318cjxlwftg">11. Propiedad intelectual</h2>
        <p data-id="element-668" data-mp="an2uknrspmby">
          Todo el contenido del Sitio, incluidos textos, imágenes, logotipos y
          diseño, es propiedad de Dermaclinic LA LLC o de sus respectivos
          propietarios y está protegido por leyes aplicables. Se prohíbe su
          reproducción sin autorización por escrito.
        </p>

        <h2 data-id="element-669" data-mp="eoxv3q1wjvoo">12. Imágenes y contenido de pacientes</h2>
        <p data-id="element-670" data-mp="eq8wjj7vkrcm">
          Cuando se utilicen imágenes de pacientes, estas se comparten con el
          consentimiento correspondiente. Los resultados individuales pueden
          variar y las imágenes no garantizan resultados futuros.
        </p>

        <h2 data-id="element-671" data-mp="2iuy0798nkrro">13. Limitación de responsabilidad</h2>
        <p data-id="element-672" data-mp="2iv7psvpscwwu">
          En la medida permitida por la ley, Dermaclinic LA LLC no será
          responsable por daños directos, indirectos, incidentales o
          consecuentes derivados del uso o la imposibilidad de uso de este
          Sitio. El Sitio se proporciona "tal cual" sin garantías de ningún
          tipo.
        </p>

        <h2 data-id="element-673" data-mp="1z6ovjzpxatba">14. Enlaces externos</h2>
        <p data-id="element-674" data-mp="1z6fdcyb4dqg5">
          El Sitio puede incluir enlaces a sitios externos. No somos
          responsables de su contenido, disponibilidad ni prácticas de
          privacidad.
        </p>

        <h2 data-id="element-675" data-mp="3amdjouewxydo">15. Modificaciones</h2>
        <p data-id="element-676" data-mp="3alc6ajafczss">
          Podemos modificar estos Términos de Servicio en cualquier momento. Los
          cambios se publicarán en esta página y entrarán en vigor al
          publicarse.
        </p>

        <h2 data-id="element-677" data-mp="3podmrd72j2lk">16. Ley aplicable</h2>
        <p data-id="element-678" data-mp="3pqq1lhhj4wue">
          Estos términos se rigen por las leyes del Estado de California,
          Estados Unidos. Cualquier disputa se resolverá en los tribunales
          competentes del Condado de Los Ángeles, California.
        </p>

        <h2 data-id="element-679" data-mp="3bya7j66lw95m">17. Contacto</h2>
        <p data-id="element-680" data-mp="3bwz3d5990zdz">
          Para preguntas sobre estos Términos de Servicio o el programa de
          mensajes SMS, contáctenos mediante la información publicada en este
          Sitio.
        </p>
      </> : <>
        <h1 data-id="element-681" data-mp="321dx2ux5dcyf">Terms of Service</h1>
        <p className="muted" data-id="element-682" data-mp="2wzoi546t0f52">Last updated: July 11, 2026</p>

        <h2 data-id="element-683" data-mp="2x2app3tp2una">1. Acceptance of terms</h2>
        <p data-id="element-684" data-mp="2sz4ls2u21fjz">
          By accessing and using this Site, you agree to these Terms of Service.
          If you do not agree, please do not use the Site.
        </p>

        <h2 data-id="element-685" data-mp="v6qt7jg5e6pe">2. Nature of the site</h2>
        <p data-id="element-686" data-mp="r6q3v3rigb3k">
          This Site is informational and designed to facilitate consultation
          requests. Information presented does not constitute medical advice,
          diagnosis, or treatment and does not establish a physician-patient
          relationship.
        </p>

        <h2 data-id="element-687" data-mp="2bpk8gn1v77o1">3. Consultation requests</h2>
        <p data-id="element-688" data-mp="2bqljirivru5r">
          Completing a consultation request does not guarantee a procedure,
          result, appointment, or candidacy. Each case is evaluated individually
          by the medical team to determine suitability and a personalized plan.
        </p>

        <h2 data-id="element-689" data-mp="38fb10gqlikr7">4. SMS program description</h2>
        <p data-id="element-690" data-mp="38e9nm5m3xm6b">
          By opting in to text messages, you agree to receive messages from
          Dermaclinic LA LLC related to appointment reminders, account updates,
          and promotional offers. Message frequency may vary based on your
          interaction with us.
        </p>
        <p data-id="element-691" data-mp="1izlc06lcc89c">
          Message and data rates may apply. Consent to receive SMS messages is
          not a condition of purchasing services.
        </p>

        <h2 data-id="element-692" data-mp="1fip953zeobi4">5. Opt-out instructions</h2>
        <p data-id="element-693" data-mp="1fhnyh0maxr0x">
          You may opt out of receiving SMS messages at any time by texting
          <strong data-id="element-694" data-mp="1bhvl8alyqwp8"> STOP</strong>. You will receive a confirmation message, and
          no further messages will be sent unless you opt in again.
        </p>

        <h2 data-id="element-695" data-mp="1peiv1dz0lhck">6. Support contact</h2>
        <p data-id="element-696" data-mp="1khad9ehs3fbu">
          For help, text <strong data-id="element-697" data-mp="1kj3hkn4x5ngo">HELP</strong> or email{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-698" data-mp="ws7j575yju0g">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>

        <h2 data-id="element-699" data-mp="ru5zol4mdsog">7. Carrier availability and liability</h2>
        <p data-id="element-700" data-mp="rra5n7vw7o5a">
          Carriers are not liable for delayed or undelivered messages. Message
          delivery depends on wireless network availability, service providers,
          and other factors outside our control.
        </p>

        <h2 data-id="element-701" data-mp="e0yaf040h99x">8. Age restriction</h2>
        <p data-id="element-702" data-mp="e057ka86b3x2">
          You must be 18 years of age or older to provide consent and receive
          SMS messages from Dermaclinic LA LLC.
        </p>

        <h2 data-id="element-703" data-mp="3jp7wvyofbimt">9. Privacy Policy</h2>
        <p data-id="element-704" data-mp="3jpzqx52dh8az">
          For more information about how we collect, use, and protect your
          information, please review our{' '}
          <Link to="/privacy" data-id="element-705" data-mp="3opm6vm9l52nh">Privacy Policy</Link>.
        </p>

        <h2 data-id="element-706" data-mp="3tm2w6jsitn25">10. Individual results</h2>
        <p data-id="element-707" data-mp="3tp8ixsdogcup">
          Aesthetic results vary between patients based on factors such as
          individual anatomy, lifestyle, age, general health, and adherence to a
          recovery plan. We do not guarantee specific results.
        </p>

        <h2 data-id="element-708" data-mp="bg7np22pu90w">11. Intellectual property</h2>
        <p data-id="element-709" data-mp="bf6aos253cgj">
          All Site content, including text, images, logos, and design, is the
          property of Dermaclinic LA LLC or its respective owners and is
          protected by applicable law. Reproduction without written
          authorization is prohibited.
        </p>

        <h2 data-id="element-710" data-mp="q7q9jgi9axs6">12. Patient images and content</h2>
        <p data-id="element-711" data-mp="u7h8i7hxsk7s">
          When patient images are used, they are shared with the applicable
          consent. Individual results may vary, and images do not guarantee
          future results.
        </p>

        <h2 data-id="element-712" data-mp="2anoftacup3no">13. Limitation of liability</h2>
        <p data-id="element-713" data-mp="2ammtg9qdwuqn">
          To the extent permitted by law, Dermaclinic LA LLC is not liable for
          direct, indirect, incidental, or consequential damages arising from
          use of, or inability to use, this Site. The Site is provided "as is"
          without warranties of any kind.
        </p>

        <h2 data-id="element-714" data-mp="2yd8wfmlj7ots">14. External links</h2>
        <p data-id="element-715" data-mp="2tepb9oerih2h">
          This Site may include links to external websites. We are not
          responsible for their content, availability, or privacy practices.
        </p>

        <h2 data-id="element-716" data-mp="2om4imq7lea0j">15. Modifications</h2>
        <p data-id="element-717" data-mp="2jp5r8ffbch61">
          We may modify these Terms of Service at any time. Changes will be
          posted on this page and become effective upon posting.
        </p>

        <h2 data-id="element-718" data-mp="3h6cwbppcexwu">16. Governing law</h2>
        <p data-id="element-719" data-mp="3cdtiqsqno2s1">
          These terms are governed by the laws of the State of California, USA.
          Any dispute shall be resolved in the competent courts of Los Angeles
          County, California.
        </p>

        <h2 data-id="element-720" data-mp="21wh18jhkyipk">17. Contact</h2>
        <p data-id="element-721" data-mp="21x8lwz9n2w12">
          For questions about these Terms of Service or the SMS messaging
          program, please email{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-722" data-mp="2gqvd802q8ruq">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>
      </>;
  return <LegalLayout data-id="element-723" data-mp="2psl494sp5orz">{content}</LegalLayout>;
}
function LegalLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <main className="min-h-screen bg-brand-cream" data-id="element-724" data-mp="2ku0bfqfry7dk">
      <header className="border-b border-brand-stone/50 py-6" data-id="element-725" data-mp="2zj67x6n89jhr">
        <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-726" data-mp="2zliobfdc7lsp">
          <Link to="/" className="flex items-baseline gap-1.5" data-id="element-727" data-mp="2ukuy2vwxn8zj">
            <span className="text-2xl font-serif font-normal text-brand-dark" data-id="element-728" data-mp="38jcm6uqr2nhz">
              Lipo Laser
            </span>
            <span className="text-[10px] font-medium tracking-[0.2em] uppercase text-brand-gold" data-id="element-729" data-mp="34ju2g2ao0igq">
              Beverly Hills
            </span>
          </Link>
          <LanguageToggle data-id="element-730" data-mp="3s6fre7z4ryj8" />
        </div>
      </header>

      <article className="container mx-auto px-6 py-20 max-w-3xl legal-content" data-id="element-731" data-mp="3s54la1i7qeoy">
        {children}
        <div className="mt-16 pt-8 border-t border-brand-stone/50" data-id="element-732" data-mp="3e891be0fb2u4">
          <Link to="/" className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/60 hover:text-brand-dark transition-colors" data-id="element-733" data-mp="3j3wqhtewnvzm">
            ← Home
          </Link>
        </div>
      </article>

      <style data-id="element-734" data-mp="398whz38rgdwa">{`
        .legal-content h1 {
          font-family: 'Playfair Display', serif;
          font-weight: 300;
          font-size: 3rem;
          color: #1B1714;
          letter-spacing: -0.02em;
          margin-bottom: 0.5rem;
        }
        .legal-content h2 {
          font-family: 'Playfair Display', serif;
          font-weight: 400;
          font-size: 1.5rem;
          color: #1B1714;
          margin-top: 2.5rem;
          margin-bottom: 0.75rem;
        }
        .legal-content p, .legal-content li {
          color: rgba(27, 23, 20, 0.75);
          line-height: 1.7;
          font-weight: 300;
          margin-bottom: 0.75rem;
        }
        .legal-content ul {
          list-style: none;
          padding-left: 1rem;
        }
        .legal-content li {
          padding-left: 1.5rem;
          position: relative;
        }
        .legal-content li::before {
          content: '·';
          color: #C9A961;
          position: absolute;
          left: 0;
          font-weight: 700;
        }
        .legal-content a {
          color: #C97B63;
          text-decoration: underline;
          text-underline-offset: 3px;
        }
        .legal-content a:hover {
          color: #1B1714;
        }
        .legal-content .muted {
          color: rgba(27, 23, 20, 0.4);
          font-size: 0.875rem;
          font-weight: 500;
          letter-spacing: 0.05em;
          margin-bottom: 3rem;
        }
        .legal-content strong {
          color: #1B1714;
          font-weight: 500;
        }
      `}</style>
    </main>;
}